import React, { useState } from "react";

type AgentThinkingStateProps = {
    messages?: any[];
};

const AgentThinkingState = ({ messages }: AgentThinkingStateProps) => {
    const [showThoughtIdx, setShowThoughtIdx] = useState<number>(-1);

    return (
        <div className="p-3 w-[80%] max-w-[617px]">
            <div className="">
                <div className="flex items-center gap-2 ">
                    <div className="flex items-center gap-2">
                        <p className="text-sm text-g-75 animate-pulse bg-gradient-to-r from-[#56B648] to-[#FFB902] bg-clip-text text-transparent">
                            Thinking...
                        </p>
                    </div>

                    {messages?.filter((message) => message?.content?.length > 0)?.length > 0 && (
                        <i
                            className={`${
                                showThoughtIdx !== -1
                                    ? "ri-arrow-down-s-line"
                                    : "ri-arrow-right-s-line"
                            } text-md bg-gradient-to-r from-[#56B648] to-[#FFB902] bg-clip-text text-transparent cursor-pointer`}
                            onClick={() => {
                                setShowThoughtIdx(showThoughtIdx === 1 ? -1 : 1);
                            }}
                        ></i>
                    )}
                </div>

                {showThoughtIdx === 1 &&
                    messages?.filter((message) => message?.content?.length > 0)?.length > 0 && (
                        <div className="flex  gap-5 items-stretch mt-2">
                            <div className="w-[1px]  bg-slate-200 relative">
                                <p
                                    className={`w-[7px] h-[7px] bg-slate-200 rounded-full flex flex-row -left-[3px] absolute top-0`}
                                ></p>
                                {messages?.length > 1 && (
                                    <p
                                        className={`w-[7px] h-[7px] bg-slate-200 rounded-full flex flex-row -left-[3px] absolute bottom-0`}
                                    ></p>
                                )}
                            </div>
                            <div className="border border-slate-200 rounded-lg py-4 px-3.5 text-sm w-full">
                                <div className="flex items-center gap-2 ">
                                    <div className="">
                                        <div className="list-disc list-inside px-2 space-y-1">
                                            {messages
                                                ?.filter((message) => message?.content?.length > 0)
                                                ?.map(
                                                    (message, idx) =>
                                                        message && (
                                                            <div className="">
                                                                {idx !== 0 &&
                                                                    messages?.length - 1 !==
                                                                        idx && (
                                                                        <p
                                                                            className={`w-[7px] h-[7px] bg-slate-200 rounded-full flex flex-row -ml-[47px] relative `}
                                                                        ></p>
                                                                    )}
                                                                <p
                                                                    className={`text-sm text-slate-500 -ml-2 `}
                                                                >
                                                                    {message?.content?.startsWith(
                                                                        "runSummary:"
                                                                    )
                                                                        ? message.content
                                                                              .slice(
                                                                                  "runSummary:"
                                                                                      .length
                                                                              )
                                                                              ?.trim()
                                                                        : message?.content}
                                                                </p>
                                                            </div>
                                                        )
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        </div>
    );
};

export default AgentThinkingState;
